import { useEffect, useState } from "react";
import NavBar from "./components/NavBar";
import { Button, Input, Space } from "antd";
import {
  addDoc,
  collection,
  getDoc,
  setDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db, auth, storage } from "./base";

function RapportoEuroPunti() {
  const [loading, setloading] = useState(true);
  const [valore, setValore] = useState("");
  const [salvato, setSalvato] = useState(false);

  async function getInitial() {
    const docRef = doc(db, "rapportoDenaroPunti", "rapportoGenerale");
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setValore(docSnap.data().rapporto);
      setloading(false);
    }
  }

  useEffect(() => {
    getInitial();
  }, []);

  async function updateValue() {
    const docRef = doc(db, "rapportoDenaroPunti", "rapportoGenerale");

    if (!valore || valore <= 0) {
      return;
    }
    try {
      await updateDoc(docRef, {
        rapporto: parseFloat(valore),
      });
      setSalvato(true);
    } catch (e) {}
  }

  if (loading) return <div></div>;
  return (
    <div>
      <NavBar />
      <main>
        {salvato ? (
          <div
            style={{
              textAlign: "center",
              border: "1px solid grey",
              borderRadius: 20,
              padding: 20,
            }}
          >
            <h2>Nuovo rapporto salvato: {valore}</h2>
            <Button
              onClick={() => {
                setSalvato(false);
              }}
              type="primary"
            >
              Cambia di nuovo
            </Button>
          </div>
        ) : (
          <div>
            <h1>Cambia rapporto Euro/punti</h1>
            <p>
              Una volta salvato, il rapporto sarà aggiornato sulle app di tutti
              i punti vendita istantaneamente
            </p>
            <Space direction="vertical" size="middle" style={{ width: "100%" }}>
              <Input
                value={valore}
                onChange={(e) => setValore(e.target.value)}
                size="large"
                type="number"
                placeholder="Rapporto euro / punti"
              />
              <Button
                disabled={valore <= 0 ? true : false}
                onClick={() => updateValue()}
                size="large"
                type="primary"
              >
                Salva
              </Button>
              <p>
                <strong>Esempi</strong>
                <p>10€ = {10 * valore} punti</p>
                <p>30€ = {30 * valore} punti</p>
                <p>50€ = {Math.floor(50 * valore)} punti</p>
              </p>
            </Space>
          </div>
        )}
      </main>
    </div>
  );
}

export default RapportoEuroPunti;
